import apisauce from 'apisauce'
import { camelizeKeys, decamelizeKeys} from 'humps'

export const authDataKeys = [
  'access-token', 'client', 'token-type', 'uid'
]

const host = process.env.NODE_ENV === 'production'
  ? 'https://api.seekrev.com' : 'http://localhost:3001'
const create = (baseURL = host + '/api/v1/') => {
  const api = apisauce.create({
    baseURL,
    headers: {
      'Content-Type': 'application/json'
    },
    timeout: 20000
  })

  api.addResponseTransform(response => {
    if (!response.config.url.includes('videos/new')) {
      response.data = camelizeKeys(response.data)
    }
  })

  api.addRequestTransform(request => {
    request.data = decamelizeKeys(request.data)
  })

  const setAuthData = authData => {
    return api.setHeaders(authData)
  }

  const deleteAuthData = () => {
    return authDataKeys.map(key => {
      return api.deleteHeader(authDataKeys)
    })
  }

  const signup = (email, password, teamName) =>
    api.post('auth', {
      email, password, team_attributes: {name: teamName},
      confirm_success_url: '/auth/reset'
    })

  const forgotPassword = (email) => {
    return api.post('auth/password', {
      email,
      redirect_url: window.location.origin + '/auth/reset'
    })
  }

  const resetPassword = (params, headers) => {
    return api.put('auth/password', params, { headers })
  }

  const googleLogin = (data) => {
    return api.post('auth/google_oauth2/callback', data)
  }

  const login = (email, password) => {
    return api.post('auth/sign_in', { email, password })
  }

  const logout = () => api.delete('auth/sign_out')

  const me = () => api.get('users/me')

  const updateProfile = (params) => api.put(`auth`, params)

  const getUsers = () => api.get('users')

  const getUser = (userId) => api.get(`users/${userId}`)

  const createUser = params => api.post('users', params)

  const updateUser = (id, params) => api.put(`users/${id}`, params)

  const deleteUser = (id, params) => api.delete(`users/${id}`, params)

  const getTeams = () => api.get('teams')

  const getPlans = () => api.get('plans')

  const getProjects = () => api.get('projects')

  const getCollaborators = (id) => api.get(`projects/${id}/collaborators`)

  const createCollaborator = (params) => api.post('collaborators', params)

  const deleteCollaborator = (collaboratorId, projectId) => {
    return api.delete(
      `collaborators/${collaboratorId}`, { project_id: projectId }
    )
  }

  const createProject = params => api.post('projects', params)

  const updateProject = (id, params) => api.put(`projects/${id}`, params)

  const deleteProject = id => api.delete(`projects/${id}`)

  const getProjectVideos = projectId => api.get(`projects/${projectId}/videos`)

  const getVideoVersions = videoId => api.get(`videos/${videoId}/versions`)

  const preUploadVideo = () => api.get('videos/new')

  const createVideo = params => api.post(`videos`, params)

  const updateVideo = (id, params) => api.put(`videos/${id}`, params)

  const deleteVideo = (id) => api.delete(`videos/${id}`)

  const unversionVideo = id => api.get(`videos/${id}/unversion`)

  const getVideoVersionComments = videoId => {
    return api.get(`videos/${videoId}/comments`)
  }

  const createComment = params => api.post(`comments`, params)

  const deleteComment = id => api.delete(`comments/${id}`)

  const searchVideoVersionComments = (videoIds, text) => {
    return api.get(
      `comments/search?video_ids=${videoIds}&text=${text}`
    )
  }

  const createSubscription = (params) => {
    return api.post('subscriptions', params)
  }

  const updateSubscription = (id, teamId, params) => api.put(`teams/${teamId}/subscriptions/${id}`, params)

  const getLinks = () => api.get('share_links')

  const createLink = params => api.post('share_links', params)

  const getSubscriptions = (teamId) => api.get(`teams/${teamId}/subscriptions`)

  const pushToJw = (id, params) => {
    return api.post(`videos/${id}/jw_push`, params)
  }

  const getActivities = (params) => {
    return api.get('activities', params)
  }

  return {
    setAuthData,
    deleteAuthData,
    signup,
    forgotPassword,
    resetPassword,
    googleLogin,
    login,
    logout,
    me,
    updateProfile,
    getUsers,
    getUser,
    createUser,
    updateUser,
    deleteUser,
    getTeams,
    getPlans,
    getProjects,
    getCollaborators,
    createCollaborator,
    deleteCollaborator,
    getProjectVideos,
    getVideoVersions,
    preUploadVideo,
    createVideo,
    updateVideo,
    deleteVideo,
    unversionVideo,
    getVideoVersionComments,
    createProject,
    updateProject,
    deleteProject,
    createComment,
    deleteComment,
    searchVideoVersionComments,
    createSubscription,
    getLinks,
    createLink,
    getSubscriptions,
    updateSubscription,
    pushToJw,
    getActivities
  }
}

export default { create }



// WEBPACK FOOTER //
// ./src/Services/Api.js